module.exports='<!-- @author Sergey Kuzhavskiy <Praffesor>--><gccs-note-list employee-id="employeeShowNotesCtrl.employeeId" editable="true"></gccs-note-list>';